export enum ValidationVisiblityEnum { // TODO: use the official "FormKit" type when available
    Blur = "blur",
    Live = "live",
    Dirty = "dirty",
    Submit = "submit"
}